import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { PageData } from 'bernie-http';

export class PwaController implements Controller {
  public bundles = ['pwa'];
  public component = codeSplit(() => import(/* webpackChunkName: "pwa" */ 'views/admin/pwa'));
  public pageId = 'page.PWAAdmin';
  public path = '/pwa';
  public exact = true;
  public routeName = 'pwa';
  public routeData = {
    rfrrNamespace: 'PWA.ADMIN',
    pageName: undefined
  };

  public fetch(options: FetchOptions): Promise<any> {
    return Promise.resolve();
  }
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({}) as Promise<PageData>;
  }
}
